import React from 'react'
import { any, fromJSX, nothing, Updater, Widget } from 'widgets-for-react'
import { getCookie } from '../../utils/cookies'
import {
  PageWithBlocks,
  PageWithBlocksState
} from '../cmsPage/cmsPageState'
import { CourseGroupPageHeader } from '../cmsPage/pages/course-group'
import { CourseCategoryPageHeader } from '../cmsPage/pages/course-category'
import { DossierPageHeader } from '../cmsPage/pages/dossier'
import { GenericPageHeader } from '../cmsPage/pages/generic'
import { HomePageHeader } from '../cmsPage/pages/home'
import { KnowledgeArticlePageHeader } from '../cmsPage/pages/knowledge-article'
import { CasePageHeader } from '../cmsPage/pages/case-detail'
import { CoursePageHeader } from '../cmsPage/pages/course-details'
import { EventPageHeader } from '../cmsPage/pages/event'
import { ActualityPageHeader } from '../cmsPage/pages/actuality-details'
import { membershipCalculatorWidget } from '../membershipCalculator/membershipCalculatorWidget'
import { ArticlePageHeader } from '../cmsPage/pages/article'

export const contentHeaderWidget = (
  page: PageWithBlocks
): Widget<Updater<PageWithBlocksState>> => {
  switch (page.kind) {
    case 'home':
      return fromJSX(() => <HomePageHeader {...page} />)
    case 'dossier':
      return fromJSX(() => <DossierPageHeader {...page} readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}/>)
    case 'generic':
      return any<Updater<PageWithBlocksState>>([
        fromJSX(() => (
          <>
            <GenericPageHeader
              {...page}
              readSpeakerCookieAccepted={
                getCookie('readspeaker-cookies') === 'yes'
              }
            />
          </>
        )),
        page.path === '/lidmaatschap' && page.membershipCalculatorState
          ? membershipCalculatorWidget(page.membershipCalculatorState)
              .map(
                updater => (state: PageWithBlocksState): PageWithBlocksState =>
                  state.kind === 'loaded' &&
                  state.value.kind === 'generic' &&
                  state.value.membershipCalculatorState
                    ? {
                        ...state,
                        value: {
                          ...state.value,
                          membershipCalculatorState: updater(
                            state.value.membershipCalculatorState
                          )
                        }
                      }
                    : state
              )
          : nothing()
      ])
    case 'knowledge-article':
      return fromJSX(() => (
        <KnowledgeArticlePageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
    case 'case-detail':
      return fromJSX(() => (
        <CasePageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
    case 'event':
      return fromJSX(() => (
        <EventPageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
    case 'article':
      return fromJSX(() => (
        <ArticlePageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
    case 'knowledge-overview':
      return nothing()

    case 'course-group':
      return fromJSX(() => (
        <CourseGroupPageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
    case 'course-category':
      return fromJSX(() => (
        <CourseCategoryPageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))

    case 'course-details':
      return fromJSX(() => (
        <CoursePageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))

    case 'actuality-details':
      return fromJSX(() => (
        <ActualityPageHeader
          {...page}
          readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
        />
      ))
  }
}
// [Custom content types]: Add case here
